<template>
  <l-main>
    <div slot="logo" slot-scope="{mini}">
      <!--<v-layout align-center class="headline text-truncate" style="height: 96px">-->
      <!--<v-flex align-center justify-center layout v-if="mini">-->
      <!--<v-avatar>-->
      <!--<img alt="logo" src="@/assets/BWC_logo_no_char.svg"/>-->
      <!--</v-avatar>-->
      <!--</v-flex>-->
      <!--<v-flex class="pl-3 pt-4" column layout v-else>-->
      <!--<span class="white&#45;&#45;text title">{{$L.cfg.appName.full}}</span>-->
      <!--<span class="font-weight-light primary&#45;&#45;text subheading">{{$L.cfg.appName.subTitle}}</span>-->
      <!--</v-flex>-->
      <!--</v-layout>-->
      <!--<v-divider></v-divider>-->
    </div>
    <template slot="toolbar-title">
      <!--<v-toolbar-title class="font-weight-regular px-0 mx-0">-->
        <v-avatar size="64px" v-ripple style="cursor: pointer"
                  class="mr-3 hidden-sm-and-down">
          <img :src="require('@/assets/平安成电logo(立体效果1)jpg.jpg')" alt="app-logo"/>
        </v-avatar>
      <span class="font-weight-regular title">{{$L.cfg.appName.full}}</span>
      <!--</v-toolbar-title>-->
    </template>
    <template slot="toolbar-items">
     <!-- <notification-menu bottom v-show="!isWxLogin">
        <v-btn @click="goNotification" icon slot="activator">
          <v-badge
            overlap=""
            size="4px"
            v-model="hasNotification"
          >
            <span slot="badge">2</span>
            <v-icon size="24">mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </notification-menu>-->
      <institution-dialog v-show="!isWxLogin">
        <v-tooltip bottom slot="activator">
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.institution</v-icon>
          </v-btn>
          <v-layout column justify-center align-center>
            <div>切换机构</div>
            <div>当前：{{insName}}</div>
          </v-layout>
        </v-tooltip>
      </institution-dialog>

      <Org-Dialog v-show="!isWxLogin">
        <v-tooltip bottom slot="activator">
          <v-btn icon slot="activator">
            <v-icon>$vuetify.icons.group</v-icon>
          </v-btn>
          <v-layout column justify-center align-center>
            <div>切换单位</div>
            <div>当前：{{orgName}}</div>
          </v-layout>
        </v-tooltip>
      </Org-Dialog>
      <v-toolbar-items  v-show="!isWxLogin">
        <user-menu>
          <v-btn flat slot="activator">
            <span class="subheading primary--text">{{loginName || '未命名'}}</span>
            <!--<div class="primary--text l-avatar">L</div>-->
            <!--<v-avatar size="36px">-->
            <!--<img alt="lazylz" src="@/assets/lazylz_avatar.jpg"/>-->
            <!--</v-avatar>-->
          </v-btn>
        </user-menu>
      </v-toolbar-items>
    </template>
    <template slot="footer">
      <app-footer></app-footer>
    </template>
  </l-main>
</template>

<script>
import AppFooter from './APP/Footer/appFooter'
import UserMenu from './APP/Menu/userMenu'
import InstitutionDialog from './APP/Menu/institutionDialog'
import OrgDialog from './APP/Menu/orgDialog'
import notificationMenu from './APP/Menu/notificationMenu'
export default {
  name: 'Main',
  components: {InstitutionDialog, UserMenu, AppFooter, OrgDialog, notificationMenu},
  data: () => ({
    hasNotification: false,
  }),
  computed: {
    isWxLogin () {
      return !(sessionStorage.getItem('isWxLogin') === null)
    },
    loginName () {
      return this.$store.state.login.name
    },
    insName () {
      return this.$store.getters['login/insName']
    },
    orgName () {
      return this.$store.getters['login/orgName']
    },
  },
  methods: {
    goNotification () {
      this.$router.push({
        name: 'Notification',
      })
    },
  },
}
</script>

<style scoped>

</style>
